import CustomHeader from "../CustomHeader";
import { TRenderCustomHeader, TRenderCustomHeaderArgs } from "../types";

const createRenderCustomHeader = (renderArgs: TRenderCustomHeaderArgs): TRenderCustomHeader => {
  const renderCustomHeader: TRenderCustomHeader = (props) => <CustomHeader {...{ ...renderArgs, ...props }} />;
  return renderCustomHeader;
};

export default createRenderCustomHeader;
